import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class RessourceService {
  uri = environment.uriG + "/api/vehicles";

  constructor(private http: HttpClient) { }

  ArchiveRessource(id):any {
    return this.http.put<any>(`${this.uri}/ressourceArchive/${id}`, {});
  }

  getAllRessources():any {
    return this.http.get<any>(`${this.uri}/ressources`);
  }

  addRessource(ressource):any {
    return this.http.post<any>(`${this.uri}/ressource`, ressource);
  }

  updateRessource(data, id):any {
    return this.http.put<any>(`${this.uri}/ressource/${id}`, data);
  }
}
